import React from 'react';

import NavBar from '../../components/common/navbar';
import SideBar from '../../components/modules/left_sidebar';
import InformacoesGrid from './InformacoesGrid';

const Administration = false;

class InformacoesPage extends React.Component {
  render() {
    const topBarMenu = this.props.location && this.props.location.state && this.props.location.state.topBarMenu;
    return (
      <div className="dashboard">
        <NavBar
          topBarMenuOption={topBarMenu}
          moduleName="Administration"
        />
        <SideBar Administration={Administration} />
        <div className="container-fluid">
          <InformacoesGrid topBarMenuOption={topBarMenu} />
        </div>
      </div>
    );
  }
}

export default InformacoesPage;
